import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import jsonp from "jsonp";
import qs from "qs";
import Cookies from "js-cookie";

// import util from "../utils/index";
import areaModule from "../utils/area";
Vue.use(Vuex);
const BASE_URL = "/api"; //http://qm.mingtikeji.com";
export default new Vuex.Store({
  state: {
    user: {},
    isLogin:
      false || localStorage.getItem("isLogin") == "success" ? true : false,
    loginDialogStatus: false,
    registerDialogStatus: false,
    registerSimpleStatus: false,
    location: {
      c_id: "",
      c_title: ""
    },
    industry: null,
    cityData: [],
    industryList: [],
    firstUrl: "",
    nameViewNew: [],
    checkNameViewNew: {},
    giveNameDialogStatus: false, //起名的
    checkSelectDialogStatus: false, // 核名的
    giveNameResultDialogStatus: false, // 评分高中低的
    bossName: "",
    bossSex: "",
    word: ""
  },
  mutations: {
    setLoginDialogStatus(state, data) {
      state.registerDialogStatus = false;
      state.loginDialogStatus = data;
    },
    setRegisterDialogStatus(state, { status, isSimple }) {
      state.registerDialogStatus = status;
      state.registerSimpleStatus = isSimple;
      state.loginDialogStatus = false;
    },
    setLocationInfo(state, data) {
      if (data.content && data.content.address_detail) {
        state.location = areaModule.getCityInfoByCityName(
          data.content.address_detail.city
        );
      }
    },
    setCityData(state, data) {
      state.cityData = data;
    },
    setIndustryList(state, data) {
      state.industryList = data;
    },
    setFirstUrl(state, data) {
      state.firstUrl = data;
    },
    setUser(state, data) {
      state.user = data;
    },
    setLoginStatus(state, data) {
      state.isLogin = data;
      localStorage.setItem("isLogin", state.isLogin);
    },
    setLoginStatusNew(state, data) {
      state.isLogin = data;
    },
    setNameViewNew(state, data) {
      state.nameViewNew = data;
    },
    setCheckNameViewNew(state, data) {
      state.checkNameViewNew = data;
    },
    logout() {
      const arg = { path: "", domain: ".mingtikeji.com" };
      Cookies.remove("FRONTENDSESSID_LM969", arg);
      Cookies.remove("mId", arg);
      Cookies.remove("mInfo", arg);
      Cookies.remove("mName", arg);
      location.reload();
    },
    setIndustry(state, data) {
      state.industry = data;
    },
    setLocation(state, data) {
      state.location = data;
    },
    setGiveNameDialogStatus(state, data) {
      state.giveNameDialogStatus = data;
    },
    setCheckSelectDialogStatus(state, data) {
      state.checkSelectDialogStatus = data;
    },
    setGiveNameResultDialogStatus(state, data) {
      state.giveNameResultDialogStatus = data;
    },
    setBossName(state, data) {
      state.bossName = data;
    },
    setBossSex(state, data) {
      state.bossSex = data === "先生" ? "1" : "2";
    },
    setWord(state, data) {
      state.word = data;
    }
  },
  actions: {
    getLocation({ commit }) {
      jsonp(
        "https://api.map.baidu.com/location/ip?ak=ia6HfFL660Bvh43exmH9LrI6",
        (err, data) => {
          if (!err) {
            commit("setLocationInfo", data);
          }
        }
      );
    },
    getCityData({ commit }, city) {
      axios
        .post(`${BASE_URL}/data/get-city-data`, {
          cityId: city.city,
          type: 4
        })
        .then(res => {
          commit("setCityData");
        });
    },
    sendSMS({ commit }, phone) {
      return axios.post(
        `https://xcxapi.niuniubang.com/companyName/login/sample`,
        qs.stringify({
          phoneNumber: phone
        })
      );
    },
    login({ commit }, phone) {
      return axios
        .post(
          `${BASE_URL}/account/login`,
          qs.stringify({
            phone
          })
        )
        .then(res => {
          commit("setLoginStatus", res.data.status);
          commit("setUser", res.data.result);
          return res;
        });
    },
    // https://lkp.phplijun.cn/login/do
    validCode({ commit }, data) {
      return axios
        .post(
          `https://xcxapi.niuniubang.com/companyName/login/do`,
          qs.stringify({
            phoneNumber: data.phone,
            verificationCode: data.code
          })
        )
        .then(res => {
          return res;
        });
    },
    register({ commit, state }, data) {
      const params = {
        ...data,
        city_name: data.city_name.c_title
      };
      if (!params.check) {
        delete params.check;
      }
      // lijun.phplijun.cn
      // https://nnb.niuniubang.com/api/xcx/createClue
      return axios
        .post(`https://nnb.niuniubang.com/api/xcx/createClue`, params)
        .then(res => {
          commit("setLoginStatus", res.data.status);
          commit("setUser", res.data.result);
          return res;
        });
    },
    registerHeming({ commit, state }, data) {
      const params = {
        ...data,
      };
      return axios
        .post(`https://nnb.niuniubang.com/api/xcx/createClue`, params)
        .then(res => {
          commit("setLoginStatus", res.data.status);
          commit("setUser", res.data.result);
          return res;
        });
    },
    // register({ commit, state }, data) {
    //   const params = {
    //     semCode: "",
    //     type: "",
    //     industry: data.industry,
    //     typeP: 31,
    //     phone: data.phone,
    //     code: data.code,
    //     pwd: "",
    //     name: data.name,
    //     city: data.city,
    //     referer: document.referrer,
    //     sub_content: data.sub_content,
    //     sub_button: data.sub_button,
    //     sub_url1: state.firstUrl,
    //     sub_url2: window.location.href
    //   };
    //   return axios
    //     .post(`${BASE_URL}/account/register`, qs.stringify(params))
    //     .then(res => {
    //       commit("setLoginStatus", res.data.status);
    //       commit("setUser", res.data.result);
    //       return res;
    //     });
    // },
    getIndustry({ commit }) {
      if (this.industryList && this.industryList.length) {
        return this.industryList;
      }
      return axios.post(`${BASE_URL}/data/new-industry`).then(res => {
        commit("setIndustryList", res.data.result);
      });
    },
    initLoginStatus({ commit }) {
      return axios.get(`${BASE_URL}/account/is-login`).then(res => {
        commit("setLoginStatus", res.data.success);
        commit("setUser", {
          name: Cookies.get("mName") || "",
          id: Cookies.get("mId") || ""
        });
      });
    },
    getCheckNameViewNew({ commit, state }, data) {
      // const params = {
      //   city: data.city,
      //   cityId: data.cityId,
      //   industry: data.industry,
      //   industryId: data.i_id,
      //   cityGroup: data.cityGroup || "", // 1省 2市 3省+市
      //   companyType: data.companyType,
      //   hotword: data.hotword,
      //   sub_content: data.sub_content,
      //   sub_button: data.sub_button,
      //   sub_url1: state.firstUrl,
      //   sub_url2: window.location.href,
      //   companyName: data.companyName.replace(/<span>|<\/span>/gi, "")
      // };
      const params = {
        ...data
      };
      return axios
        .post(
          `https://nnb.niuniubang.com/ad_api/nameVerify`,
          qs.stringify(params)
        )
        .then(res => {
          // console.log(res, "9999-9999");
          commit("setCheckNameViewNew", res.data);
          return res;
        });
    },
    getNameViewNew({ commit, state }, data) {
      // const params = {
      //   cityGroup: data.cityGroup || "", // 1省 2市 3省+市,
      //   companyType: data.companyType,
      //   hotCount: data.hotCount,
      //   industryId: "",
      //   cityId: data.cityId,
      //   industry: data.industry,
      //   curPage: data.curPage,
      //   limit: data.limit,
      //   sub_content: "",
      //   sub_button: "",
      //   sub_url1: state.firstUrl,
      //   sub_url2: window.location.href,
      //   search: data.search,
      //   name_demand: data.name_demand
      // };
      const params = {
        addrs: state.location.c_title,
        birthday: "",
        bossName: state.bossName,
        //city_id: 1,
        sex: state.bossSex,
        typeName: state.industry,
        word: state.word,
        zichang: "2"
      };
      return axios({
        headers: {
          "Content-Type": "application/json"
        },
        url: "https://nnb.niuniubang.com/ad_api/getCompanyName", //"https://lkp.phplijun.cn/nameBaby/getNamesByFrom",
        method: "post",
        data: params
      }).then(res => {
        commit("setNameViewNew", res.data);
        return res;
      });
    },
    classLogin({ commit, state }, data) {
      return axios
        .post(`https://nnb.niuniubang.com/api/kjs/createClue`, data)
        .then(res => {
          return res;
        });
    },
  },
  modules: {}
});
